import React from "react";
import { BarekamIcon } from "../../icon/barekam-icon";
import { InputProps } from "@mui/material";
import BarekamText from "../../text";
import { AttachmentIcons, OrderIcons } from "../../icon/variants";
import { AttachmentRowContainer } from "../styled";
import BarekamButton, { SimpleButtons } from "../../button";
import { GapContainer } from "../../card/styled";
import fileService from "../../../../services/file-service";

const BarekamFileRow = ({ file, disabled, remove }: BarekamFileInputProps) => {
    async function onDocumentDownload() {
        if (file instanceof File) {
            const blob = new Blob([file], { type: file.type });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        } else {
            const url = await fileService.downloadFileById(file.fileId);

            if (url) {
                window.open(url.data.downLoadURL, '_blank')
            }
        }
    }

    function getDocumentIcon() {
        if (file?.contentType?.endsWith('/pdf') || file?.type?.endsWith('/pdf')) {
            return AttachmentIcons.pdf;
        } else if (file?.contentType?.endsWith('/doc') || file?.contentType?.endsWith('docx') || file?.type?.endsWith('docx') || file?.type?.endsWith('doc')) {
            return AttachmentIcons.doc;
        }

        // TODO
        return AttachmentIcons.image;
    }

    return (
        <AttachmentRowContainer>
            <BarekamIcon variant={getDocumentIcon()} onClick={() => onDocumentDownload()} />

            <BarekamText variant={"m"}
                align={"left"}
                overflow={'hidden'}
                width={'100%'}>
                {file.fileName || file.name}
            </BarekamText>

            <GapContainer>
                <BarekamButton type={SimpleButtons.LINK}
                    onClick={() => onDocumentDownload()}>
                    <BarekamIcon variant={AttachmentIcons.download} />
                </BarekamButton>

                {disabled
                    ? ''
                    : <BarekamButton type={SimpleButtons.LINK} onClick={() => remove && remove(file)}>
                        <BarekamIcon variant={OrderIcons.removeProduct} />
                    </BarekamButton>
                }
            </GapContainer>
        </AttachmentRowContainer>
    );
};

export default BarekamFileRow;

interface BarekamFileInputProps extends InputProps {
    file: any,
    disabled?: boolean;
    remove?: any;
}
